import { useEffect, useLayoutEffect, useState } from "react";
// import AppRoute from "./routes/AppRoute";
import { selectedTheme } from "./config/themes";
// import BottomTabs from "./components/Navbar/BottomTabs";
import Layout from "./layout/Layout";
import useResponse from "./hooks/useResponse";
import { markUserGestureStart, resetUserGesture } from "./utils/userGesture";
import useDisableZoom from "./hooks/useDisableZoom";
import { useSelector } from "react-redux";
import { initGA } from "./lib/google";
import initializeCleverTap from "./lib/clevertap";

export default function App() {
  useDisableZoom();

  const { isStepperDisabled } = useSelector((state) => state.user);
  const [isClevertapInitialized, setIsClevertapInitialized] = useState(false);

  const { handleStep, token, location } = useResponse();

  useEffect(() => {
    if (
      token &&
      !isStepperDisabled &&
      location.pathname !== "/" &&
      location.pathname !== "/home" &&
      location.pathname !== "/enter-otp" &&
      location.pathname !== "/confirm-details" &&
      location.pathname !== "/select-loan" &&
      location.pathname !== "/payment-status"
    ) {
      handleStep();
    }
  }, [token]);

  useEffect(() => {
    if (!isClevertapInitialized && window.clevertap != null) {
      setIsClevertapInitialized(true);
    }
    if(isClevertapInitialized) {
      initializeCleverTap();
    }
  }, [isClevertapInitialized]);

  useEffect(() => {
    const theme = selectedTheme();
    Object.keys(theme).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, theme[key]);
    });

    initGA();
  }, []);

  useEffect(() => {
    const gestureEvents = ["click", "change", "input"];

    gestureEvents.forEach((event) => document.addEventListener(event, markUserGestureStart, true));

    return () => {
      gestureEvents.forEach((event) => document.removeEventListener(event, markUserGestureStart, true));
    };
  }, []);

  useLayoutEffect(() => {
    resetUserGesture();
  }, [location.pathname]);


  return (
    <>
      <Layout />
      {/* <AppRoute /> */}
    </>
  );
}
